import React from 'react';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import AdminReviewsManagement from '../../../../components/siteadmin/WhyHostPageSettings/AdminReviewsManagement/AdminReviewsManagement';

import s from './AdminReviews.css';

const AdminReviews = () => {

    return <AdminReviewsManagement />

}

export default withStyles(s)(AdminReviews);